export default "__VITE_ASSET__be92ea66__"